<script>
import Layout from "../../layouts/main.vue";
import PageHeader from "@/components/page-header";
import appConfig from "../../../app.config";
import axios from 'axios';
import DataTable from 'datatables.net-vue3';
import moment from 'moment';
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import Multiselect from "@vueform/multiselect";
import "@vueform/multiselect/themes/default.css";

export default {
    page: {
        title: "Active Orders",
        meta: [{ name: "description", content: appConfig.description }],
    },

    data() {
        return {
            role:localStorage.getItem('role'),
            title: "Active Orders",
            items: [
                {
                text: "Active Orders",
                href: "/",
                },
            ],

            rangeDateconfig: {
                mode: "range",
                dateFormat: "Y-m-d",
            },
        
            customerOrderList:[],
            loadingDetail:false,
            loadingRoles:true,
            isButtonDisabled:false,
            date: '',
            key_search:'',
            program_id:null,
            programList:null,
            dtKey:0,
            call_verification:null,
            call_verificationoption : [{
                    value:1,
                    label:'Completed'
                },
                {
                    value:0,
                    label:'Not Completed'
                },
                {
                    value:2,
                    label:'Failed'
                }
                ],
            data_verification:null,
            data_verificationoption : [{
                    value:1,
                    label:'Completed'
                },
                {
                    value:0,
                    label:'Not Completed'
                },
                {
                    value:2,
                    label:'Failed'
                }
                ],
            orderstatusList: null,
            order_status_id: null,
            isLoadingExport: false,
        };
    },

    methods: {
        format_date(value){
            if (value) {
                return moment(String(value)).format('YYYY-MM-DD HH:mm:ss')
            }
        },

        currentDate() {
            const current = new Date();
            const date = `${current.getDate()}/${current.getMonth()+1}/${current.getFullYear()}`;
            return date;
        },

        lastthirtyday(){
            return moment().subtract(30, 'days').format('DD/MM/YYYY')
        },

        downloadExcel: function () {
            //location.href= process.env.VUE_APP_API_BASEURL+'order/export';
            if(this.order_status_id!= null){
                if(this.order_status_id.length == 0){
                    this.order_status_id = '';
                }
            }
            if(this.program_id != null){
                if(this.program_id.length == 0){
                    this.program_id = '';
                }
            }
            if(this.call_verification != null){
                if(this.call_verification.length == 0){
                    this.call_verification = '';
                }
            }
            if(this.data_verification != null){
                if(this.data_verification.length == 0){
                    this.data_verification = '';
                }
            }
             const posting_ = {                
                date: this.date,
                key_search: this.key_search,
                program_id: this.program_id,
                call_verification: this.call_verification,
                data_verification: this.data_verification,
                order_status_id: this.order_status_id,
            };

            this.isLoadingExport = true;
            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
            axios.post(process.env.VUE_APP_API_BASEURL+'order/export', posting_, {responseType: 'blob'})
            .then(response => {
                if (response) {                    
                    var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                    var fileLink = document.createElement('a');
   
                    fileLink.href = fileURL;
                    fileLink.setAttribute('download', 'Orders List.xlsx');
                    document.body.appendChild(fileLink);
   
                    fileLink.click();
                } 
                else {
                    this.messageBag = ['No record.'];
                }
            })
            .catch(error => {
                if(error.response.status == 422){
                    alert(error.response.data.message ?? 'Please select date order range.');
                }if(error.response.status == 400){
                    alert(error.response.message ?? 'Please make sure date range below 90 days.');
                }
                this.messageBag = [error.error];
            })
            .finally(() => {
                this.isLoadingExport = false;
            });
        },

        getCustomerOrderList(){
            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
            axios.get(process.env.VUE_APP_API_BASEURL+'program/all_order')
            .then(response => {
                if (response) {
                    this.loadingRoles=false;
                    this.customerOrderList = response.data;
                } 
                else {
                    this.messageBag = ['No record.'];
                }
            })
            .catch(error => {
                this.messageBag = [error.error];
            });
        },

        submitForm(e)
        {
            this.isButtonDisabled=true;
            e.preventDefault()
            if(this.order_status_id!= null){
                if(this.order_status_id.length == 0){
                    this.order_status_id = '';
                }
            }
            if(this.program_id != null){
                if(this.program_id.length == 0){
                    this.program_id = '';
                }
            }
            if(this.call_verification != null){
                if(this.call_verification.length == 0){
                    this.call_verification = '';
                }
            }
            if(this.data_verification != null){
                if(this.data_verification.length == 0){
                    this.data_verification = '';
                }
            }
            const posting_ = {                
                date: this.date,
                key_search: this.key_search,
                program_id: this.program_id,
                call_verification: this.call_verification,
                data_verification: this.data_verification,
                order_status_id: this.order_status_id,
            };

            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
            axios.post(process.env.VUE_APP_API_BASEURL+'order/search', posting_)
            .then(response => {
                if (response) {
                    this.loadingRoles=false;
                    this.customerOrderList = response.data;
                    this.dtKey +=1;
                } 
                else {
                    this.messageBag = ['No record.'];
                }
            })
            .catch(error => {
                this.messageBag = [error.error];
            })
            .finally(() => {
                this.isButtonDisabled = false;
            });
        },

        resetForm: function () { 
            this.date = ''; 
            this.key_search = ''; 
            this.program_id = null; 
            this.call_verification = null; 
            this.data_verification = null; 
            this.order_status_id=null;
            // this.getCustomerOrderList();
        },

        get_program(){
            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
            axios.get(process.env.VUE_APP_API_BASEURL+'program/raw_data')
            .then(response => {
                if (response) {
                    this.programList = response.data;
                    const programListmap = this.programList.map((programList) => {
                        return {
                            value: programList.id,
                            label: programList.program_name,
                        }
                        })
                    this.programList = programListmap;
                } 
                else {
                    this.messageBag = ['No record.'];
                }
            })
            .catch(error => {
                this.messageBag = [error.error];
            });
        },

        get_order_status(){
            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
            axios.get(process.env.VUE_APP_API_BASEURL+'orderstatus/list')
            .then(response => {
                if (response) {
                    this.orderstatusList = response.data;
                    const statuslist = this.orderstatusList.map((orderstatusList) => {
                        return {
                            value: orderstatusList.id,
                            label: orderstatusList.name,
                        }
                        })
                    this.orderstatusList = statuslist;
                } 
                else {
                    this.messageBag = ['No record.'];
                }
            })
            .catch(error => {
                this.messageBag = [error.error];
            });
        },
        getCurrency() {
            return process.env.VUE_CURRENCY || 'SGD';
        },
    },

    components: {
        Layout,
        PageHeader,
        DataTable,
        flatPickr,
        Multiselect,
    },

    mounted() {
        this.getCustomerOrderList();
        this.get_program();
        this.get_order_status();
       
    },
    
};
require("@/assets/css/datatable.css");
</script>
<style>
/* .col-xl-8 {
    flex: 0 0 auto;
    width: 82.66667% !important;
} */
</style>
<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <!--button type="button" class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#add_new_program_modal"  v-if="this.role = 1"><i class="ri-add-line align-middle me-1"></i> Add New Program</button> <br><br-->
        <div class="card">
            <div class="card-header border-bottom-dashed">
                <div class="row g-4 align-items-center">
                    <div class="col-sm">
                        <div>
                            <h5 class="card-title mb-0">Order List</h5>
                        </div>
                    </div>
                    <div class="col-sm-auto">
                        <div>
                            <button @click="downloadExcel()" class="btn btn-success" v-if="this.role != 3"
                                :disabled="isLoadingExport"
                            >
                                <template v-if="isLoadingExport">
                                    Exporting...
                                </template>
                                <template v-else>
                                    <i class="ri-file-excel-2-line align-middle me-1"></i>Export Excel
                                </template>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card-body border-bottom-dashed border-bottom">
                <form @submit.prevent="submitForm">
                <div class="row g-3">
                    <div class="col-xl-4">
                        <div class="search-box">
                            <input type="text" class="form-control search"
                            placeholder="Search for Order Number" v-model="key_search"/>
                            <i class="ri-search-line search-icon"></i>
                        </div>
                    </div>
                    <!--end col-->
                    <div class="col-xl-8 pb-3">
                        <div class="row g-2">
                            <div class="col-sm-6">
                                <div class="">
                                    <flat-pickr v-model="date" placeholder="Select Order Date" :config="rangeDateconfig"
                                    class="form-control"></flat-pickr>
                                </div>
                            </div>
                            <!--end col-->
                            <div class="col-sm-6">
                                <div>
                                    <!-- <select v-model="data_verification" class="form-select mb-4">
                                        <option value="" disabled>Select Data Verification</option>
                                        <option value="1">Completed</option>
                                        <option value="0">Not Completed</option>
                                        <option value="2">Failed</option>
                                    </select> -->
                                    <Multiselect placeholder="Select Data Verification" v-model="data_verification" mode="tags" :close-on-select="true" :searchable="true"
                                    :create-option="false" :options="data_verificationoption" />
                                </div>
                            </div>
     
                           
                            <!--end col-->

                             <!-- <div class="">
                                <Multiselect class="form-control" placeholder="Select" v-model="tagvalue" mode="tags" :close-on-select="true" :searchable="true"
                                    :create-option="false" :options="tagoption" />
                            </div> -->
                            <!--end col-->
                        </div>
                    </div>


                    <div class="col-xl-12 pb-3">
                        <div class="row g-2">
                           
                            <div class="col-sm-4">
                                <div>
                                <!-- <select v-model="call_verification" class="form-select mb-4">
                                    <option value="" disabled>Select Call Verification</option>
                                    <option value="1">Completed</option>
                                    <option value="0">Not Completed</option>
                                    <option value="2">Failed</option>
                                </select> -->
                                <Multiselect placeholder="Select Call Verification" v-model="call_verification" mode="tags" :close-on-select="true" :searchable="true"
                                    :create-option="false" :options="call_verificationoption" />
                                </div>
                            </div>
                           
                            <!--end col-->

                            <div class="col-sm-4">
                                <!-- <select v-model="program_id" class="form-select mb-4">
                                    <option value="" disabled>Select Program</option>
                                    <option v-for="(item, index) in programList" :key="index" :value="item.id" >
                                        {{ item.program_name }}
                                    </option>
                                </select> -->
                                <Multiselect placeholder="Select Program" v-model="program_id" mode="tags" :close-on-select="true" :searchable="true"
                                    :create-option="false" :options="programList" />
                            </div>

                            <div class="col-sm-4">
                                <!-- <select v-model="order_status_id" class="form-select mb-3">                                   
                                    <option value="" disabled>Select Status</option>
                                    <option v-for="(item, index) in orderstatusList" :key="index" :value="item.id" >
                                        {{ item.name }}
                                    </option>
                                </select> -->
                                <Multiselect placeholder="Select Status" v-model="order_status_id" mode="tags" :close-on-select="true" :searchable="true"
                                    :create-option="false" :options="orderstatusList" />
                              
                            </div>
                             <!-- <div class="">
                                <Multiselect class="form-control" placeholder="Select" v-model="tagvalue" mode="tags" :close-on-select="true" :searchable="true"
                                    :create-option="false" :options="tagoption" />
                            </div> -->
                            <!--end col-->
                        </div>
                    </div>

                    
                </div>
                <div class="row g-3 justify-content-end">
                    <div class="col-xl-2">
                        <div>
                            <button type="submit" class="btn btn-primary w-100" :disabled="isButtonDisabled">
                                <i class="ri-equalizer-fill me-2 align-bottom"></i>Search
                            </button>
                        </div>
                    </div>
                    <!--end col-->
                    <div class="col-xl-2">
                        <div>
                            <button type="button" @click='resetForm' class="btn btn-danger w-100">
                                <i class="ri-refresh-fill me-2 align-bottom"></i>Reset
                            </button>
                        </div>
                    </div>
                </div>
                <!--end row-->
                </form>
            </div>
            <div class="card-body">
                <h6>** Orders data display from {{lastthirtyday()}} to {{currentDate()}}</h6>
                <div class="live-preview">
                    <div class="row align-items-center g-12">
                        <div class="col-lg-12">
                            <div v-if='loadingRoles'>
                                <div class="spinner-border text-success" role="status">
                                    <span class="sr-only">Loading...</span>
                                </div>
                            </div>
                            <div v-else>
                                <div class="table-responsive">
                                <DataTable :options="{lengthChange: false,searching: false}" :key="dtKey" class="table table-striped table-nowrap mb-0" id="example"> 
                                     <thead class="table-secondary">
                                        <tr>
                                            <th>#.</th>
                                            <th scope="col">Order Number</th>           
                                            <th scope="col">Curlec Ref ID</th>           
                                            <th scope="col">Order Date</th>
                                            <th scope="col">Status</th>
                                            <th scope="col">Credit Check Status</th>           
                                            <th scope="col">Customer Name</th>           
                                            <th scope="col">Data Verification</th>           
                                            <th scope="col">Call Verification</th>                                                      
                                            <th scope="col">Program</th>
                                            <th scope="col">Application Source</th>
                                            <th scope="col">Application Branch</th>
                                            <th scope="col">Program Fee</th>
                                            <th scope="col">Device Name</th>
                                            <th scope="col">GST (%)</th>
                                            <th scope="col">SKU</th>
                                            <th scope="col">Price</th>
                                            <!--th scope="col">Created On</th-->
                                        </tr>
                                    </thead>

                                    <tbody>                        
                                        <tr v-for="(item, index) in customerOrderList" :key="index" class="content">
                                            <td>{{ index+1 }}</td>
                                            <td><router-link :to="'/orders/customer-order-details/'+item.cid" class="fw-medium link-secondary">{{ item.orderId }}</router-link></td>                               
                                            <td>{{ item.referenceNumber }}</td>
                                            <td>{{ format_date(item.created_at) }}</td>
                                            <td>{{ item.order_status_name }}</td>
                                            <td>{{ item.credit_check_result }}</td>
                                            <!--td>{{ item.first_name }} {{ item.last_name }}</td-->
                                            <td><router-link :to="'/customer/customer-details/'+item.cid" class="fw-medium link-secondary">{{ item.name_as_per_nric }}</router-link></td>
                                            <td v-if="item.data_verification == 1"><span class="badge bg-success">YES</span></td>
                                            <td v-else-if="item.data_verification == 2"><span class="badge bg-danger">FAILED</span></td>
                                            <td v-else><span class="badge bg-secondary">NO</span></td>
                                            <td v-if="item.call_verification == 1"><span class="badge bg-success">YES</span></td>
                                            <td v-else-if="item.call_verification == 2"><span class="badge bg-danger">FAILED</span></td>
                                            <td v-else><span class="badge bg-secondary">NO</span></td>
                                            <td>{{ item.program_name }}</td>
                                            <td>{{ item.program_type }}</td>
                                            <td>{{ item.branchname }}</td>
                                            <td>{{ this.getCurrency() }} {{ item.program_fee }}</td>
                                            <td>{{ item.product_name }}</td>
                                            <td>{{ item.gst }}</td>  
                                            <td>{{ item.sku }}</td>                                          
                                            <td>{{ this.getCurrency() }} {{ item.price }}</td>                                          
                                                                                       
                                        </tr>
                                    </tbody>
                                </DataTable>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>